module.exports = __webpack_public_path__ + "static/img/logo_ico.c642c92.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/bbc54yyk/logo_ico.svg
// module id = 1870
// module chunks = 0